import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { RESOURCES } from "@/lib/siteData";
import { FadeUp } from "./Shared";

export const Resources = () => (
  <section id="resources" data-testid="resources-section" className="px-6 md:px-12 py-24 md:py-40 bg-[#060606]">
    <div className="mx-auto max-w-[1500px]">
      <FadeUp className="flex items-baseline gap-4 mb-14 md:mb-20 border-b border-[var(--line)] pb-6">
        <span className="font-mono-plex text-xs text-[var(--muted)]">04</span>
        <span className="font-mono-plex text-xs uppercase tracking-[0.28em] text-[var(--muted)]">Legal Resources</span>
      </FadeUp>

      <FadeUp className="max-w-3xl mb-14">
        <h2 className="font-serif-display font-light text-4xl md:text-6xl tracking-tight leading-[0.95]">
          Notes & guidance from <span className="italic">the practice.</span>
        </h2>
      </FadeUp>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--line)] border border-[var(--line)]">
        {RESOURCES.map((r, i) => (
          <motion.a
            key={i}
            href="#consult"
            data-testid={`resource-card-${i}`}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="group bg-[#060606] p-8 md:p-10 flex flex-col justify-between min-h-[280px] hover:bg-[var(--bg-2)] transition-colors duration-500"
          >
            <div className="flex items-center justify-between">
              <span className="font-mono-plex text-[10px] uppercase tracking-[0.22em] text-[var(--muted)] border border-[var(--line)] px-3 py-1">{r.tag}</span>
              <ArrowUpRight size={18} className="text-[var(--muted)] transition-all duration-300 group-hover:text-[var(--off)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </div>
            <div>
              <h3 className="font-serif-display text-2xl md:text-3xl leading-tight mb-4">{r.title}</h3>
              <span className="font-mono-plex text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">{r.read}</span>
            </div>
          </motion.a>
        ))}
      </div>
      <FadeUp className="mt-8">
        <p className="font-mono-plex text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">More articles coming soon</p>
      </FadeUp>
    </div>
  </section>
);
